import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioCapexExt } from '@/classes/scenario/ren-fr/capex/ScenarioCapexExt';

const getDefaultFields = () => new ScenarioCapexExt();

export const buildCapexModule = () => {

  @Module({
    namespaced: true
  })
  class CapexModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioCapexExt {
      return this.getConfig.ren_fr_pv ? new ScenarioCapexExt(this.getConfig.capex) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return CapexModule;
};
